import React from "react";
import jwt_decode from "jwt-decode";
import S from "./MessageFile.styled";
import FileIcon from "../../assets/icons/FileIcon";
import { useFeatureFlags } from "../..";
export default function MessageFile({ token }) {
    var _a, _b, _c, _d;
    const { file } = jwt_decode(token);
    const { storageUrl, imagePreview } = useFeatureFlags();
    if (!file || !storageUrl)
        return null;
    const downloadFile = (React.createElement(S.Anchor, { href: `${storageUrl}/file?fileToken=${token}`, download: file === null || file === void 0 ? void 0 : file.originalname }, "Download File"));
    return (React.createElement(React.Fragment, null, imagePreview && (file === null || file === void 0 ? void 0 : file.mimetype.startsWith("image/")) ? (React.createElement(S.PreviewWrapper, null,
        React.createElement("img", { src: `${storageUrl}/file?fileToken=${token}`, alt: "" }),
        downloadFile)) : (React.createElement(S.Wrapper, null,
        React.createElement(FileIcon, null),
        React.createElement(S.TextWrapper, null,
            React.createElement(S.FileName, null, file === null || file === void 0 ? void 0 : file.originalname),
            React.createElement(S.FileExtension, null, (_d = (_c = (_b = (_a = file === null || file === void 0 ? void 0 : file.mimetype) === null || _a === void 0 ? void 0 : _a.split("/")) === null || _b === void 0 ? void 0 : _b[1]) === null || _c === void 0 ? void 0 : _c.toUpperCase()) !== null && _d !== void 0 ? _d : ""),
            downloadFile)))));
}
//# sourceMappingURL=MessageFile.js.map